export default __webpack_public_path__ + "static/media/CAFFENIO_white.c227920e.svg";